const PaginationToLast = ({ paginationData, moveToLast }) => {
  if (
    paginationData.has_next_page &&
    paginationData.current_page < paginationData.page_count - 1
  ) {
    return (
      <button
        className="pagination__step pagination__step--last"
        onClick={moveToLast}
      >
        <svg
          className="w-6 h-6 text-gray-800 dark:text-white"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.6"
            d="m17 16-4-4 4-4m-6 8-4-4 4-4"
          />
        </svg>
      </button>
    );
  } else return null;
};

export default PaginationToLast;
